import { supabase } from '../lib/supabase'

/** Columnas de la base de soluciones, con los tickets donde se aplicó. */
const SOLUTION_COLUMNS =
  'id,title,description,createdAt,createdBy,ticketSolution(ticketId)'

export const solutionService = {
  schemaName: 'Tickets',
  tableName: 'solution',

  /**
   * Busca en la base de soluciones (título o contenido), excluyendo las
   * borradas, de la más reciente a la más antigua.
   * @param {Object} params
   * @param {string} [params.query=''] - Texto a buscar.
   * @param {number} [params.page=0]
   * @param {number} [params.pageSize=30]
   * @returns {Promise<{success: boolean, data: {items: Array<Object>, total: number}|null, error: string|undefined}>}
   *   Cada item trae `ticketIds` (tickets donde se aplicó).
   */
  async search({ query = '', page = 0, pageSize = 30 } = {}) {
    try {
      const from = page * pageSize
      let request = supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select(SOLUTION_COLUMNS, { count: 'exact' })
        .or('deleted.is.null,deleted.eq.false')
        .order('createdAt', { ascending: false })
        .range(from, from + pageSize - 1)

      // Comas y paréntesis rompen la sintaxis de `or` de PostgREST.
      const term = query.trim().replace(/[,()]/g, ' ')
      if (term) {
        request = request.or(
          `title.ilike.%${term}%,description.ilike.%${term}%`
        )
      }

      const { data, error, count } = await request
      if (error) throw error
      return {
        success: true,
        data: {
          items: (data || []).map(({ ticketSolution, ...s }) => ({
            ...s,
            ticketIds: (ticketSolution || []).map((t) => t.ticketId),
          })),
          total: count ?? 0,
        },
      }
    } catch (error) {
      console.error('Error searching solutions:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async DeleteSolutionTicketId(solutionId, ticketId) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from('ticketSolution')
        .delete()
        .eq('solutionId', solutionId)
        .eq('ticketId', ticketId)

      //  console.log('DeleteSolutionTicketId - solutionId:', solutionId, 'ticketId:', ticketId, 'error:', error)
      if (error) throw error
      return { success: true, data: null, error: null }
    } catch (error) {
      console.error(
        '[DeleteSolutionTicketId] Error deleting solution by solutionId:',
        error
      )
      return { success: false, data: null, error: error.message }
    }
  },

  async DeleteSolution(solutionId) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .delete()
        .eq('id', solutionId)
      if (error) throw error
      return { success: true, data: null, error: null }
    } catch (error) {
      console.error('Error deleting solution by solutionId:', error)
      return { success: false, data: null, error: error.message }
    }
  },
}
